export default __webpack_public_path__ + "static/media/user.8e7ab55d.jpg";